import React, { forwardRef, useRef, useImperativeHandle } from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'

import { useAuthenticationState } from '../../../../../contexts/AuthenticationContext'
import { userMenuMessages } from '../../../../../translations'
import { baseTiltifyUrl, getSubdomainUrl } from '../../../../../utils'
import { Button } from '../../../../Button'

const StyledButton = styled(Button)`
  display: flex;
  font-size: 0.8125rem !important;
  font-weight: normal !important;
  padding: 0.625rem 1.0625rem;
  border: none;
  color: ${({ theme }) => theme.textColor} !important;
`

export const FrontendUserDashboard = forwardRef((props, ref) => {
  const { user } = useAuthenticationState()
  const { formatMessage } = useIntl()
  const localRef = useRef()
  useImperativeHandle(ref, () => localRef.current)
  const baseURL = getSubdomainUrl(baseTiltifyUrl(), 'app')
  return (
    <StyledButton forwardedAs='a' href={`${baseURL}/users/${user.slug}`} ref={localRef}>
      {formatMessage(userMenuMessages.dashboard)}
    </StyledButton>
  )
})
